module.exports = __webpack_public_path__ + "static/img/background.e49069a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/background.png
// module id = J24T
// module chunks = 6